import React from 'react'
import { cn } from '@/utilities/cn'

interface SidebarCardProps {
  title: string
  children: React.ReactNode
  className?: string
  actions?: React.ReactNode
}

export function SidebarCard({ title, children, className = '', actions }: SidebarCardProps) {
  return (
    <div className={cn('bg-white rounded-2xl border border-slate-200 p-6', className)}>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-slate-900">{title}</h3>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
      {children}
    </div>
  )
}
